import { makeStyles } from "tss-react/mui";

const useOutlinedDatePickerStyles = makeStyles()((theme) => ({
  root: {
    "& .MuiInputBase-root": {
      color: theme.palette.text.primary,
    },
  },
  whiteFilled: {
    border: `1px solid ${theme.palette.strokes.defaultGrey}`,
    "& .MuiInputBase-root": {
      backgroundColor: theme.palette.surface.light,
      color: theme.palette.text.primary,
    },
  },
}));

export default useOutlinedDatePickerStyles;
